export enum ENakupProdej {
    N = 'N',
    P = 'P',
    NK = 'NK'
}
